var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCalendarSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6F6F6",
    width: 48,
    height: 48,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h24v24H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25 14.25A.75.75 0 0 1 30 15v1.5h.75a3 3 0 0 1 2.995 2.824l.005.176v11.25a3 3 0 0 1-3 3h-13.5a3 3 0 0 1-3-3v-7.5l.001-.03-.001-3.72a3 3 0 0 1 2.824-2.995l.176-.005H18V15a.75.75 0 0 1 .648-.743l.102-.007a.75.75 0 0 1 .75.75v1.5h9V15a.75.75 0 0 1 .648-.743l.102-.007zm1.5 7.5h-13.5a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.501l-.007-.143a1.5 1.5 0 0 0-1.349-1.35l-.144-.006zm0-3.75h-13.5a1.5 1.5 0 0 0-1.5 1.5v1.152l.034-.02c.385-.216.823-.35 1.29-.377l.176-.005h13.5c.533 0 1.033.139 1.466.382l.034.02V19.5a1.5 1.5 0 0 0-1.356-1.493L30.75 18z",
    fill: "#979797",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendarSquare);
export default __webpack_public_path__ + "static/media/ico-calendar-square.03c4fad29fcfbd611591f273c1f1f7d1.svg";
export { ForwardRef as ReactComponent };